<div
  id="weatherWidgety"
  class="garminwidget"
  [class]="
    'style' + weather.weather.condition.code + '_' + weather.weather.is_day
  "
>
  <div style="width: 100%; display: inline-block">
    <p [class]="'topLine_' + weather.weather.is_day">{{ activity.name }}</p>
    <img
      style="position: absolute; right: 60px"
      [src]="'/assets/images' + weather.weather.condition.icon"
    />
  </div>
  <div style="display: flex">
    <div
      style="
        display: flex;
        min-width: 30vw;
        pointer-events: none;
        min-height: 24vw;
      "
    >
      <app-polyline-map
        [showBaseLayer]="false"
        [mapId]="mapId"
        *ngIf="activity.map?.polyline || activity.map?.summary_polyline"
        [polyline]="activity.map?.summary_polyline"
        [type]="activity.type"
      ></app-polyline-map>
      <h1 class="garminDistance" *ngIf="activity.distance > 0">
        {{ activity.distance | distance : "show" }}
      </h1>
      <h1
        class="garminDistance"
        style="padding: 0; margin: auto; position: relative"
        *ngIf="activity.distance === 0"
      >
        {{ activityMinutes }}
      </h1>
    </div>
    <table class="garminTable">
      <tr>
        <td [class]="'columnLeft_' + weather.weather.is_day">Temp</td>
        <td class="columnWhite" *ngIf="!isImperial">
          {{ weather.weather.temp_c }} °C
        </td>
        <td class="columnWhite" *ngIf="isImperial">
          {{ weather.weather.temp_f }} °F
        </td>
      </tr>
      <tr>
        <td [class]="'columnLeft_' + weather.weather.is_day">Wind</td>
        <td class="columnWhite" *ngIf="!isImperial">
          {{ weather.weather.wind_kph }} km/h {{ weather.weather.wind_dir }}
        </td>
        <td class="columnWhite" *ngIf="isImperial">
          {{ weather.weather.wind_mph }} mi/h {{ weather.weather.wind_dir }}
        </td>
      </tr>
      <tr>
        <td [class]="'columnLeft_' + weather.weather.is_day">Humidity</td>
        <td class="columnWhite">{{ weather.weather.humidity }} %</td>
      </tr>
      <tr>
        <td [class]="'columnLeft_' + weather.weather.is_day">Time</td>
        <td class="columnWhite">{{ activity.moving_time | elapsed }}</td>
      </tr>
    </table>
  </div>
</div>
